export default __webpack_public_path__ + "static/media/NEW-AGIFLY-GIF-ADERCO.4bff744b.gif";